import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
`;

export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6,
  > p {
    text-align: center;
    color: ${({ focusTextColour }) => focusTextColour || themeGet('colors.dark-text')};
  }

  > h3 {
    font-weight: 700;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 45px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 90px 0;

    h2 {
      font-size: 36px;
      line-height: 38px;
    }
  }

  /* Add class header styles to override sizes when chosen as tags */
  .h2 {
    font-size: 36px;
    line-height: 38px;
  }

  .h3 {
    font-weight: 700;
    line-height: 24px;
  }

  .h4 {
    font-size: 22px;
    line-height: 32px;
  }

  .h5 {
    font-size: 18px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 45px 0px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 90px 0;
  }
`;

export const CenterImage = styled(Image)`
  margin: 0 auto;
  max-width: 340px;
  border-radius: 5px 5px 0px 0px;
  align-items: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0;
    flex-grow: 1;
    width: 33%;

    img{
      width: 340px;
    }
  }
`;

export const OverviewWrapper = styled(Container)`
  width: 100%;
  margin: 0;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
  }
`;

export const OverviewContainer = styled(Container)`
  width: 100%;
  margin: 20px 0;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    width: 30%;

    &.left-side-container{
    padding: 0 60px 0 0;
    }

    &.right-side-container{
      padding: 0 0 0 60px;
      }
  }
`;

export const Content = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 20px 0;

  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    font-weight: ${themeGet('font-weights.bold')};
    color: ${themeGet('colors.text-secondary')};
    text-align: center;
    margin-bottom: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.left-side{
      justify-content: flex-start;
      margin-right: 20px;
    }

    &.right-side{
      justify-content: flex-start;
    }
  }

`;

// note: defined width because of gatsby image and flex - fluid image sizes don't have a width and disappear
export const OverviewImage = styled(Image)`
  flex-grow: 1;
  border-radius: 5px 5px 0px 0px;
  align-items: left;
  margin-right: 20px;
  max-width: 90px;
  width: 90px;
  flex-shrink: 0;
  
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-right: 10px;
  }
`;
